import { useEffect, useState } from 'react';
import { useData } from '../context/DataContext';
import FloatingButtonMenu from './layout/FloatingButtonMenu';
import WorkIcon from '@mui/icons-material/Work';
import { Box, CircularProgress, ListItemIcon, ListItemText, MenuItem, MenuList, Button } from '@mui/material';
import { useNavigate } from "react-router-dom";

function Home() {
  const navigate = useNavigate();
  const { surveys, checkToken, getSurveyList } = useData();
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    getSurveyList();

    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };

    window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
    };
  }, [checkToken, getSurveyList]);

  const handleInstallClick = () => {
    if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === 'accepted') {
          console.log('User accepted');
        } else {
          console.log('User rejected');
        }
        setDeferredPrompt(null);
      });
    }
  };

  return (
    <div className="flex flex-col justify-center items-center w-full h-full">
      <FloatingButtonMenu />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          padding: 3,
          backgroundColor: "#fff",
          borderRadius: 2,
          boxShadow: 3,
          width: "30%",
          minWidth: 300,
        }}
      >
        <Box
          sx={{
            width: "50%",
            minWidth: 75,
          }}
        >
          <img src={process.env.REACT_APP_LOGO} alt="Logo" />
        </Box>
        <h1 className="text-3xl">Surveys</h1>
        {surveys ? (
          <MenuList>
            {surveys.map((mapItem) => (
              <MenuItem key={mapItem.id}>
                <ListItemIcon>
                  <WorkIcon fontSize="small" />
                </ListItemIcon>
                <ListItemText primary={mapItem.title} secondary="" onClick={() => { navigate('/survey/' + mapItem.id) }} />
              </MenuItem>
            ))}
          </MenuList>
        ) : (
          <CircularProgress />
        )}
        {deferredPrompt && (
          <Button variant="contained" onClick={handleInstallClick}>
            Install App
          </Button>
        )}
      </Box>
    </div>
  );
}

export default Home;
